import React from 'react';
import Text from 'Components/Text';

export default class AdditionalSection extends React.Component {
  getInputValue = id => {
    const {system} = this.props;

    if (!system) return '';

    const element = system.optionValueRequests.find(option => option.optionId === id);
    if (element) return element.value;
    else return '';
  };

  __isVisible = () => {
    return this.props.isActive ? '' : '__invisible'
  };

  render() {
    const {currentSystemConfiguration} = this.props;

    if (!currentSystemConfiguration) return null;
    if (!currentSystemConfiguration.options || !currentSystemConfiguration.options.length) return null;

    return (
      <section className={`boat-systems-details-section__system-additional-info-section ${this.__isVisible()}`}>
        {currentSystemConfiguration.options.map((input, index) => {
          let units = '';
          switch (input.optionType) {
            case 'INCHES':
              units = 'In.';
              break;
            case 'SQUARE_INCHES':
              units = 'Sq. In.';
              break;
            case 'CUBUC_FOOT':
              units = 'Cu. Ft.';
              break;
            default:
              break;
          }

          switch (input.optionType) {
            case 'VARIANTS':
            case 'INTEGER':
            case 'INCHES':
            case 'STRING':
            case 'SQUARE_INCHES':
            case 'CUBUC_FOOT':
              return (
                <div className='grid-cell'>
                  <Text
                    key={input.id}
                    label={input.name}
                    value={this.getInputValue(input.id)}
                    style={{ gridColumn: 1, gridRow: index + 1 }}
                    units={units}
                    decimalDigits={2}
                  />
                </div>
              );
            default:
              return (
                input.options.map((input, index) => {
                  if (input.optionType === null) {
                    return (
                      <div key={input.id} className='grid-cell multi' style={{ gridColumn: 2, gridRow: index + 1 }}>
                        <div className='multi-label'>{input.name}</div>
                        <div className='multi-fields-wrapper'>
                          {input.options.map(input => {
                            const units = input.optionType === 'SQUARE_INCHES' ? 'Sq. In.' : '';
                            return (
                              <Text
                                key={input.id}
                                label={input.name}
                                value={this.getInputValue(input.id)}
                                units={units}
                                decimalDigits={2}
                              />
                            );
                          })}
                        </div>
                      </div>
                    );
                  }
                  return null;
                }));
          }
        })}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/BoatSystems/AdditionalSection.jsx